import { Popper as MuiPopper } from '@mui/material';

export default MuiPopper;
